import InsightsOutlined from "@mui/icons-material/InsightsOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";

const InsightsPage = lazy(() => import("pages/insights/InsightsPage"));

const insightRoutes: Array<Page | PageGroup> = [
  {
    segment: "insights",
    title: "Insights",
    Icon: InsightsOutlined,
    Component: InsightsPage,
  },
];

export default insightRoutes;
